"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
interface Props {
  children: ReactNode;
}
export default function QueryProvider(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  const [queryClient] = useState(_temp);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = process.env.NODE_ENV === "development" && <ReactQueryDevtools initialIsOpen={false} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== queryClient) {
    t2 = <QueryClientProvider client={queryClient}>{children}{t1}</QueryClientProvider>;
    $[1] = children;
    $[2] = queryClient;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 300000,
        gcTime: 1800000
      }
    }
  });
}